import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { withRouter } from "react-router-dom";
import './AppStyle.css';

class App extends Component {
  componentDidMount = async () => {
    if(this.props.authenticated) {
      var {from} = this.props.location.state || {from: {pathname: '/'}};


      await Promise.all(
        [
          this.props.getUserPremiumStatus(),
          this.props.getStripeDetails(),
          this.props.getUserPersonalDetails()
        ]
      );
    }
  }
  render() {
    return (
      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', backgroundColor: '#F9FBFD' }}>
      {/*backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'noRepeat',
      backgroundImage: 'url(' + require('../assets/background.jpg') + ')',*/}
        <Header history={this.props.history}/>
        <div className="main flex-container">{this.props.children}</div>
        <Footer />
      </div>
    );
  }
}

function mapStatetoProps({auth}) {
  return { authenticated: auth.authenticated };
}

export default withRouter(connect(mapStatetoProps, actions)(App));
